import { render, staticRenderFns } from "./OrderinstaModal.vue?vue&type=template&id=961b9500&scoped=true&"
import script from "./OrderinstaModal.vue?vue&type=script&lang=js&"
export * from "./OrderinstaModal.vue?vue&type=script&lang=js&"
import style0 from "./OrderinstaModal.vue?vue&type=style&index=0&id=961b9500&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "961b9500",
  null
  
)

export default component.exports